declare namespace $ {

	type $mol_button_minor__sub_shm_projects_goal_thinking_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_projects_goal_thinking_2 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_thinking['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_projects_goal_thinking_3 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_thinking['status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_projects_goal_thinking_4 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_thinking['part_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_thinking_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_projects_goal_thinking_6 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_thinking['part_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $shm_hitalama_text__text_shm_projects_goal_thinking_7 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_thinking['part_text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_card__sub_shm_projects_goal_thinking_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	export class $shm_projects_goal_thinking extends $mol_page {
		Close_icon( ): $mol_icon_close
		close( next?: any ): any
		Close( ): $mol_button_minor
		status( ): string
		Status( ): $mol_paragraph
		part_rows( ): readonly(any)[]
		Parts( ): $mol_view
		Thinking_box( ): $mol_view
		part_title( id: any): string
		Part_title( id: any): $mol_paragraph
		part_text( id: any): string
		Part_text( id: any): $shm_hitalama_text
		entries( ): readonly(any)[]
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Part( id: any): $mol_card
	}
	
}

//# sourceMappingURL=thinking.view.tree.d.ts.map